import React from "react";
import { ImQrcode } from "react-icons/im";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useToast } from "../../hooks/useToast";
import "../../index.scss";
import QRCodeScreen from "../QRCodeScreen";
import { useAppContext } from "../../context/AppContext";
import { FABImage, FABWrapper, RotateOnHover } from "./styled";
import ScreenCard from "../ScreenCard";
import {
  MdQrCode /*MdComment, MdSettings, MdTranslate*/,
} from "react-icons/md";

//FloatingActionButton
const FAB: React.FC = () => {
  const { getLocation, getExhibitName, selectedExhibitId, hasCoordinates } =
    useAppContext();
  const { showToast } = useToast();

  // Get organization name directly from context
  const location = getLocation();
  const organizationName = location?.companyName || "";

  const qrImage =
    process.env.REACT_APP_API_URL + "exhibit/qr?id=" + selectedExhibitId;

  // Get page name directly from context when needed
  const pageName = getExhibitName(selectedExhibitId) ?? "";

  const shareNow = () => {
    try {
      const shareData = {
        title: "Share the Joy: " + organizationName,
        text: pageName,
        url: window.location.href,
      };
      if (navigator.share) {
        if (navigator.canShare) {
          navigator
            .share(shareData)
            .then(() => {
              showToast("success", "Content shared successfully!");
            })
            .catch((error) => {
              showToast(
                "error",
                "An error occurred while sharing. Please try again."
              );
            });
        } else {
          showToast("warning", "This content cannot be shared on this device.");
        }
      } else {
        showToast("warning", "Sharing is not supported on this device.");
      }
    } catch (error) {
      showToast("warning", "This device cannot share!");
    }
  };

  const MySwal = withReactContent(Swal);
  const handleQRCodeClose = () => {
    MySwal.close();
  };
  const handleQRCodeShare = () => {
    shareNow();
    handleQRCodeClose();
  };
  const handleQRCodeCancel = () => {
    handleQRCodeClose();
  };

  const tabs = [
    {
      icon: MdQrCode,
      label: "Share",
      content: (
        <QRCodeScreen
          organizationName={organizationName}
          pageName={pageName}
          image={qrImage}
          onShareButton={() => shareNow()}
        />
      ),
    },
    // {
    //   icon: MdTranslate,
    //   label: "Language",
    //   content: <div>Language Content</div>,
    // },
    // {
    //   icon: MdComment,
    //   label: "Feedback",
    //   content: <div>Feedback Content</div>,
    // },
    // {
    //   icon: MdSettings,
    //   label: "Viiision",
    //   content: <div>Viiision Content</div>,
    // },
  ];

  const renderFAB = () => {
    return location?.headerLogo ? (
      <FABImage src={location?.headerLogo} alt=""></FABImage>
    ) : (
      <ImQrcode style={{ width: 30, height: 30 }} />
    );
  };

  const showSwal = () => {
    MySwal.fire({
      html: (
        <ScreenCard
          tabs={tabs}
          primaryColor={location?.qrcodeProperties?.eyes_inner_color}
        />
      ),
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
      width: "340px",
      customClass: {
        popup: "custom-swal-popup",
      },
      didOpen: () => {
        document
          .querySelector(".swal2-close")
          ?.addEventListener("click", handleQRCodeClose);
        document
          .querySelector(".swal2-cancel")
          ?.addEventListener("click", handleQRCodeCancel);
        document
          .querySelector(".swal2-confirm")
          ?.addEventListener("click", handleQRCodeShare);
      },
    });
  };

  return (
    <FABWrapper $hasCoordinates={hasCoordinates}>
      <RotateOnHover>
        <div onClick={showSwal}>{renderFAB()}</div>
      </RotateOnHover>
    </FABWrapper>
  );
};

export default FAB;
